import {useState} from 'react';
import {Input} from '~/components';
import {motion} from 'motion/react';
import {MagnifyingGlassIcon} from '@heroicons/react/24/outline';

export function Search({className}) {
  const [showSearch, setShowSearch] = useState(false);
  const [buttonVars, setButtonVars] = useState({
    initial: {opacity: 0, x: 0},
    animate: {opacity: 1, x: 0},
    exit: {opacity: 0, x: 0},
    transition: {duration: 0.3},
  });

  const handleShowSearch = () => {
    setShowSearch(true);
    setButtonVars({
      ...buttonVars,
      animate: {opacity: 0, x: -10},
    });
  };

  const handleCloseSearch = () => {
    setShowSearch(false);
  };

  return (
    <>
      {showSearch ? (
        <SearchInput className={className} handleClose={handleCloseSearch} />
      ) : (
        <motion.button className={className} onClick={handleShowSearch}>
          <span className="sr-only">Search</span>
          <MagnifyingGlassIcon className="w-6 h-6" />
        </motion.button>
      )}
    </>
  );
}

export function SearchInput({className, searchTerm, handleClose}) {
  const [isSearchTerm, setIsSearchTerm] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    window.location.href = `${window.location.origin}/search?q=${isSearchTerm}`;
    handleClose();
  };

  return (
    <form className={`relative flex w-full ${className}`}>
      <motion.div
        initial={{x: 50, width: 0}}
        animate={{x: 0, width: '100%'}}
        exit={{x: 50, width: 0}}
        transition={{
          duration: 0.3,
          ease: 'easeOut',
        }}
      >
        <Input
          className={className}
          defaultValue={searchTerm}
          placeholder="Search…"
          type="search"
          variant="search"
          name="q"
          onChange={(e) => setIsSearchTerm(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              handleSubmit(e);
            }
            if (e.key === 'Escape') {
              handleClose();
            }
          }}
        />
      </motion.div>
      <button
        className="absolute right-[0.5rem] mt-2"
        type="submit"
        onClick={handleSubmit}
      >
        <MagnifyingGlassIcon className="w-6 h-6" />
      </button>
    </form>
  );
}

